import { ButtonSize, ButtonVariants } from '@anm/components/buttons/Button';
import Confirm from '@anm/components/notification/Confirm';
import { FC } from 'react';

export type ConfirmDeleteProps = {
  stopText: string;
  title?: string;
  description?: string;
  onClose?: () => void;
  onStopStream?: () => void;
};

const ConfirmStopStream: FC<ConfirmDeleteProps> = ({ title, description, stopText, onClose, onStopStream }) => (
  <Confirm
    {...{ title }}
    buttonLeft={{
      text: 'Cancel',
      size: 'upper-medium' as ButtonSize,
      variant: 'blue-heavy-border' as ButtonVariants
    }}
    buttonRight={{
      text: stopText,
      size: 'upper-medium' as ButtonSize,
      color: 'red',
      variant: 'red' as ButtonVariants
    }}
    onLeftButtonClick={onClose}
    onRightButtonClick={onStopStream}
  >
    {description}
  </Confirm>
);

export default ConfirmStopStream;
